<template>
  <div class="card-header">
    <div class="card-header-bg">
      <div class="header-content">
        <div class="header-img">
          <img :src="formData.img" alt />
        </div>
        <div class="header-img-lable">
          <span>*</span>
          <span>上传职业形象照片</span>
        </div>
        <div class="header-uploader">
          <van-uploader :max-size="1000 * 1024" @oversize="onOversize" :after-read="imagePhoto" >
            <svg-icon icon-class="card_but"></svg-icon>
          </van-uploader>
        </div>
        <div class="header-default-bg">
          没有职业装？试试选用系统
          <span>默认名片背景</span>
        </div>
      </div>
    </div>
    <div class="card-cell">
      <van-cell-group>
        <div class="card-cell-sty">
            <van-field required center input-align="right" is-link  label="头像" >
          <template #input>
            <van-uploader :after-read="upHeaderImg">
              <img class="header-img" :src="formData.bodyImg" alt />
            </van-uploader>
          </template>
        </van-field>
        </div>
        <div class="uploader-wx-qr">
          <van-cell center title="微信二维码上传" value="内容" label="建议截图上传，添加更方便">
            <template #default>
              <van-uploader :after-read="WXimg">
                <img class="wx-img-uploader" :src="formData.weixinImg" alt />
              </van-uploader>
            </template>
          </van-cell>
        </div>
        <div>
        <van-field center input-align="right" is-link v-model="formData.wxCode" label="微信号"  placeholder="请输入微信号"/>
        </div>
        <div class="card-cell-sty">
            <van-field required center input-align="right" is-link v-model="formData.name" label="姓名" placeholder="请输入姓名" />
        </div>
        <div class="card-cell-sty">

        <van-field  required center input-align="right" is-link v-model="formData.tel" label="联系电话" placeholder="请输入联系电话" />
        </div>
        <van-field center input-align="right" is-link v-model="formData.comName" label="公司名称" placeholder="请输入公司名称" />
        <div >
        <van-field center input-align="right" is-link v-model="formData.position" label="职位" placeholder="请输入职位" />
            
        </div>
        <van-field center input-align="right" is-link v-model="formData.address" label="公司地址" placeholder="请输入公司地址" />
        <div class="card-textarea">
          <div class="business">
            <div class="business-label">
              <div class="business-title">主营业务</div>
              <div>
                <span>{{remnant}}</span>/150
              </div>
            </div>
            <textarea
              placeholder="主营业务让客户了解公司的业务范围，方便客户匹配自身需求。如：保险、贷款、银行等"
              v-model="formData.mainBusiness"
              @input="descInput"
              maxlength="150"
              name="idContent"
              class="width"
            ></textarea>
          </div>
          <div class="business">
            <div class="business-label">
              <div class="introduce-title">公司介绍</div>
              <div>
                <span>{{remnant1}}</span>/150
              </div>
            </div>
            <textarea
              placeholder="公司介绍是对企业和品牌背书，添加公司介绍有利于增加客户信任。如："
              v-model="formData.introduce"
              @input="introduceInput"
              maxlength="150"
              name="idContent"
              class="width"
            ></textarea>
          </div>
        </div>
      </van-cell-group>
    </div>
    <div class="card-but">
      <!-- <div class="but-cancel common-but">取消</div> -->
      <div v-if="editId" class="but-finish" @click.prevent="renew">更新保存</div>
      <div v-else class="but-finish" @click.prevent="submit">完成创建</div>
    </div>
  </div>
</template>

<script>
import URL from '@/api/api'
import { Toast } from 'vant';
export default {
  data() {
    return {
      remnant: 0,
      remnant1: 0,
      isUploaderPhoto:0,
      isUpHeaderImg:0,
      formData: {
        introduce: '',
        address: '',//地址
        bodyImg: require('./img/header_img.png'),//头照
        comName: '',//公司名
        img: require('./img/header.png'), //形象照
        mainBusiness: '',//主营业务
        name: '',//姓名
        position: '',//职位
        tel: '',//手机号
        userId: localStorage.getItem('userid'),//用户id
        weixinImg: require('./img/uploader.png'),//微信二维码
        wxCode: '',//微信号
        id:'',//修改id
      },
      editId:''
    }
  },
  watch: {
    formData(curVal, oldVal) {
      if (curVal.length >= 150) {
        this.remnant = 0
        this.remnant1 = 0
        this.formData.business = curVal.substring(0, 150)
        this.formData.introduce = curVal.substring(0, 150)
      }

    }

  },
  mounted(){
    this.getStaffcard()
  },
  methods: {
    descInput() {
      let txtVal = this.formData.business.length;
      this.remnant = txtVal;
    },
    introduceInput() {
      let txtVal = this.formData.introduce.length;
      this.remnant1 = txtVal;
    },
    getStaffcard(){//名片查询
      this.$fetchGet(URL.getStaffcard.url,{id:this.formData.userId}).then(res=>{
        if(res.data.code==20000){
          this.formData=res.data.data
          this.editId=res.data.data.id
        }
      })
    },
    // 创建
    submit(){
        if(this.isUploaderPhoto){
            Toast('请上传个人职业形象照片')
        }else if(this.isUpHeaderImg){
            Toast('请上传个人头像')
        }else if(this.formData.name==''){
            Toast('请输入姓名')
        }else if(this.formData.tel==''){
            Toast('请输入联系电话')
        }else if(this.formData.mainBusiness==''){
            Toast('请输入主营业务')
        }else{
          this.$fetchPost(URL.staffcard.url,this.formData).then(res=>{
            if(res.data.code==20000){
              Toast(res.data.msg)
            }
          })
        }

    },
    //更新
    renew(){
      this.$fetchPost(URL.staffcard.url,this.formData).then(res=>{
        if(res.data.code==20000){
          Toast(res.data.msg)
        }
      })
    },
    onOversize(file) {
      Toast('文件大小不能超过 10MB');
    },
    imagePhoto(file){//形象照片
      
      let data = new FormData();
      data.append("file", file.file);
      data.append("bucketName", 'loan');
      this.$fetchPost(URL.upImg.url, data).then((res) => {
        if(res.data.code==20000){
          this.isUploaderPhoto=1
          this.formData.img = res.data.data.fileUrl
        }
      })
    },
    upHeaderImg(file){//头像上传
      let data = new FormData();
      data.append("file", file.file);
      data.append("bucketName", 'loan');
      this.$fetchPost(URL.upImg.url, data).then((res) => {
        if(res.data.code==20000){
          this.isUpHeaderImg=1
          this.formData.bodyImg = res.data.data.fileUrl
        }
      })
    },
    WXimg(file){//微信二维码
      let data = new FormData();
      data.append("file", file.file);
      data.append("bucketName", 'loan');
      this.$fetchPost(URL.upImg.url, data).then((res) => {
        if(res.data.code==20000){
          this.formData.weixinImg = res.data.data.fileUrl
        }
      })
    }
  }

}
</script>

<style lang="less" scoped>
.card-header {
//   height: auto;
  padding-bottom: 10px;
  background: #fff;
  .card-header-bg {
    width: 375px;
    height: 340px;
    background: url("./img/bg.png") no-repeat 100%;
    background-size: 100% 100%;
    overflow: hidden;
    .header-content {
      width: 355px;
      height: 307.5px;
      margin: 16px auto;
      border-radius: 10px;
      border: 1px dotted #999999;
      // opacity: 0.6;
      .header-img {
        width: 95px;
        height: 95px;
        margin: 29.5px auto 0;
        img {
          width: 100%;
        }
      }
      .header-img-lable {
        width: 223.5px;
        height: 20px;
        line-height: 20px;
        margin: auto;
        text-align: center;
        font-size: 14px;
        color: #333333;
        span {
          display: inline-block;
          height: 20px;
          line-height: 20px;
        }
      }
      .header-img-lable span:first-child {
        margin-right: 8px;
        color: #fc6e09;
      }
      .header-uploader {
        width: 223.5px;
        height: 43.5px;
        margin: 20.5px auto 0;
        .svg-icon {
          width: 223.5px;
          height: 43.5px;
        }
      }
      .header-default-bg {
        width: 226.5px;
        height: 16.5px;
        margin: 24px auto 0;
        font-size: 12px;
        font-weight: Regular;
        font-family: PingFang SC;
        color: #666666;
        span {
          color: #fa6622;
        }
      }
    }
  }
  .card-cell {
      .card-cell-sty{
        .van-cell::before {
            position: absolute;
            left: 8px;
            color: #FC6E09;
            font-size: 14px;
            content: '*';
        }
    }
    img {
      display: block;
    }
    .van-cell {
      line-height: 52.5px;
      padding: 0 20px;
      font-size: 14px;
      font-weight: bold;
      color: #333333;
    }
    /deep/.van-field__label{
        color: #333333;
    }
    
    .header-img {
      width: 32px;
      height: 30px;
    }
    .wx-img-uploader {
      width: 56px;
      height: 40px;
    }
    .uploader-wx-qr {
      .van-cell {
        height: 81px;
        line-height: 20px;
        padding: 0 20px;
      }
    }
  }
  .card-textarea {
    .business {
      margin-top: 18.5px;
      padding: 0 20px;
      font-size: 14px;
      color: #333333;
      border: 1px solid transparent;
      .business-label {
        display: flex;
        justify-content: space-between;
      }
      .business-title,
      .introduce-title {
        font-size: 14px;
        font-weight: Bold;
        font-family: PingFang SC;
        color: #333333;
      }
      .business-title::before {
        position: absolute;
        left: 8px;
        color: #FC6E09;
        font-size: 14px;
        content: "*";
      }
      
      textarea {
        width: calc(100% - 36px);
        height: 102px;
        margin-top: 17.5px;
        padding: 13px 16px;
        border: 0.5px solid #ededed;
      }
    }
  }
  .card-but {
    width: 335px;
    height: 36px;
    // display: flex;
    margin: 46px auto 27.5px auto;
    // justify-content: space-between;
    font-size: 14px;
    font-weight: Medium;
    font-family: PingFang SC;
    color: #fc6e09;
    .but-finish{
        width: 156px;
        height: 36px;
        margin: auto;
        line-height: 36px;
        text-align: center;
        color: #FFFFFF;
        background: url('./img/but1.png') no-repeat 100%;
        background-size: 100% 100%;
    }
  }
}
</style>